module.exports = __webpack_public_path__ + "img/phase1-2013-02.4e180af7.jpg";